import { FC } from 'react'
import { Outlet } from 'react-router'
import { useTranslation } from 'react-i18next'
import { IconName } from '@enbw/ui-react'
import cn from 'classnames'
import styles from './styles.module.scss'
import { useAppStore } from '@/stores/useAppStore'
import { AppHeader } from '@/application/layouts/AppLayout/components/AppHeader'
import { ModuleBar, ModuleBarItem } from '@/application/layouts/AppLayout/components/ModuleBar'
import { Paths } from '@/paths'
import { UserRole } from '@/application/auth/types/userRole'
import { useAuth } from '@/application/auth/hooks/useAuth'

export const AppLayout: FC = () => {
  const { hasAnyRole } = useAuth()
  const { t } = useTranslation()
  const { isDarkMode } = useAppStore()

  const moduleBarItems: ModuleBarItem[] = [
    {
      path: Paths.CONTRACTS_SEARCH,
      icon: IconName.Contract,
      label: t('navigation.contracts'),
      visible: hasAnyRole([UserRole.Reader, UserRole.Developer])
    },
    {
      path: Paths.OPERATIONS,
      icon: IconName.Settings,
      label: t('navigation.operations'),
      visible: hasAnyRole([UserRole.Developer])
    }
  ]

  return (
    <div
      className={cn({
        dark: isDarkMode,
        [styles.homeLayoutDark]: isDarkMode
      })}
    >
      <AppHeader />
      <div className={styles.homeLayout}>
        <ModuleBar items={moduleBarItems} />
        <div className={styles.homeLayoutContent}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
